export enum BoardMoveSetting {
  NOT_ALLOWED,
  ALLOWED_WITHIN_ORG,
  ALLOWED_ALL_ORGS,
}
